<template>
  <c-form-dialog
    :model-value="isShown"
    :title="$t('main.provide_messenger')"
    :description="$t('main.add_messenger_details')"
    @update:model-value="closeDialog()"
  >
    <social-networks
      :errors="errors"
      :chosen-messengers="userMessenger"
      @select-messengers="userMessenger = $event"
    />
    <c-btn
      block
      color="primary"
      :height="42"
      class="mt-5"
      :loading="messengerIsLoading"
      :label="$t('main.confirm')"
      @click="addMessenger()"
    />
  </c-form-dialog>
</template>

<script>
  import { CBtn, CFormDialog } from '@clickadilla/components/components'
  import { personalRepository } from '@/services/repository-factory'
  import handleErrors from '@/services/handleErrors'
  import useNotification from '@/services/useNotification'
  import SocialNetworks from '@/views/Register/SocialNetworks/Index.vue'

  const { showSuccessNotification } = useNotification()

  export default {
    name: 'AddMessengerDialog',
    components: {
      CBtn,
      CFormDialog,
      SocialNetworks
    },
    props: {
      isShown: {
        type: Boolean,
        required: true
      }
    },
    emits: ['close-dialog'],
    data() {
      return {
        messengerIsLoading: false,
        userMessenger: [],
        errors: {}
      }
    },
    methods: {
      async addMessenger() {
        const messengerRequest = this.userMessenger.map((messenger) => ({
          messenger_id: messenger.id,
          nickname: messenger.nickname
        }))
        try {
          this.messengerIsLoading = true
          await personalRepository.addMessenger({
            messengers: [...messengerRequest]
          })
          showSuccessNotification(this.$t('main.success'))
          this.closeDialog()
        } catch (error) {
          this.errors = handleErrors(error)
        }
        this.messengerIsLoading = false
      },
      closeDialog() {
        this.$emit('close-dialog')
      }
    }
  }
</script>
